import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {ContextIdDto, LinkId, Notification} from '@savvy/notification';
import {Customer, CustomerService} from "@savvy/customer";
import {FloSnackbarComponent} from "../../snackbar/floSnackbar.component";
import {
  LinkIds,
  MessagecompService,
  MessageService,
  MSISDN,
  SendSavvyMessage,
  SendSmsMessage,
  SmsRecipient
} from "@savvy/messaging";
import {ViewCustomerV2Component} from "../../customer/view-customer-v2/view-customer-v2.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-savvy-message-notification',
  templateUrl: './savvyMessageReceivedNotification.component.html'
})
export class SavvyMessageReceivedNotificationComponent implements OnInit {

  @Input() notification: Notification;
  @Input() contextIdDto: ContextIdDto;

  @Output() notificationProcessed: EventEmitter<any> = new EventEmitter();

  customer: Customer;

  error = null;
  replyMesssage = null;
  showTextbox = false;
  replyDone = false;
  replyToMsisdn: string = null;

  constructor(private notify: FloSnackbarComponent,
              public dialog: MatDialog,
              private customerService: CustomerService,
              private messageService: MessageService,
              private messagecompService: MessagecompService) {
  }

  ngOnInit(): void {
  //  this.loadCustomer();
  }


  loadCustomer() {
    this.customerService.loadCustomer(this.notification.customerId, this.contextIdDto.contextId,
      this.contextIdDto.contextIdType).subscribe(response => {
        this.customer = response;
    })
  }

  getLinkId(type: string, linkIds: Array<LinkId>): string {
    let linkIdToRet;

    linkIds.forEach(linkId => {
      if (linkId.linkedIdType === type) {
        linkIdToRet = linkId.linkedId;
      }
    });
    return linkIdToRet;
  }

  sendSavvyMessage(notification: Notification) {
    console.warn('todo');

    /*  const customerId = this.getLinkId('CUSTOMER_ID', notification.linkIds);
      const userId = this.getLinkId('USER_ID', notification.linkIds);
      if (this.replyToMsisdn) {
        const req = <SendSavvyMessage>{};
        req.contextId = this.contextIdDto.contextId;
        req.contextIdType = this.contextIdDto.contextIdType;
        req.message = this.replyMesssage;
        // req.smsSenderId = this.smsSenderId;
        const linkIds = <LinkIds>{};
        linkIds.linkIds = new Array();
        const linkId: LinkId = {
          linkedId: customerId,
          linkedIdType: 'CUSTOMER_ID'
        };
        const linkUserId: LinkId = {
          linkedId: userId,
          linkedIdType: 'USER_ID'
        };
        linkIds.linkIds.push(linkId);
        linkIds.linkIds.push(linkUserId);
        req.linkIds = linkIds;

        req.toNumbers = [];
        const smsRecipient = <SmsRecipient>{};
        smsRecipient.recipient = <MSISDN>{};
        smsRecipient.recipient.msidn = this.replyToMsisdn;

        smsRecipient.userId = {
          id: userId
        };
        req.toNumbers.push(smsRecipient);
        this.messagecompService.sendSmsMessage(req).subscribe(response => {
          let errorMessage = undefined;
          if (response?.sendMessageResponses) {
            for (let message of response.sendMessageResponses) {
              if (message.message.errorMessage) {
                errorMessage = message.message.errorMessage;
                break;
              } else if (message.errorMessage) {
                errorMessage = message.errorMessage;
              }
            }
          }

          if (!errorMessage) {
            this.replyMesssage = null;
            this.showTextbox = false;
            this.replyDone = true;
          } else {
           // this.hideNotifications();
            this.notify.message = 'Failed to send sms. ' + errorMessage;
            this.notify.open();
          }

        }, error => {

        });
      }*/

  }

  reply(notification: Notification) {

    console.warn('todo');

    /*
    const messageId = this.getLinkId('MESSAGE_ID', notification.linkIds);
    if (messageId) {
      this.messageService.getMessage(messageId, this.contextIdDto.contextId, this.contextIdDto.contextIdType).subscribe(response => {
        if (response?.smsMessage?.fromNumber?.msidn) {
          this.showTextbox = true;
          this.replyToMsisdn = response?.smsMessage?.fromNumber?.msidn;
          console.log('set replyToMsisdn to ', response?.smsMessage?.fromNumber?.msidn);
        } else {
          this.error = true;
          this.replyToMsisdn = null;
        }
      }, error => {
        this.error = true;
      });
    } else {
      this.error = true;
    }*/
  }

  viewCustomer(customerId: string) {
    const contextIdDto = this.contextIdDto;
    const viewCustomerModal = this.dialog.open(ViewCustomerV2Component, {
      data: {
        contextIdDto,
        customerId
      },
      maxWidth: '1024px',
      panelClass: [
        'modal-100',
        'helpwindow',
        'petProfileModal'
      ],
      autoFocus: false
    });

    viewCustomerModal.afterClosed()
      .subscribe(
        () => {
        });
  }

}
